import React, { forwardRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import { LangInfo } from '../lang-info/LangInfo';
import { LangChooserButton } from '../lang-chooser-button/LangChooserButton';
import type { ILocaleLang } from '../../../../app/types/appReducer.t';

type ICustomToggleProps<T>  = T & {
    toggleButtonComponent?: React.FC<T>
}

const CustomToggle = forwardRef<HTMLDivElement, ICustomToggleProps<{}>>((argument, ref) => {
    const { toggleButtonComponent, ...props } = argument;
    const ToggleComponent = toggleButtonComponent || LangChooserButton;
    return (
            <div ref={ref}>
                <ToggleComponent {...props}/>
            </div>
    );
});

interface ILangChooserDropdownProps {
    onSelectLang: (eventKey?: string | null, e?: React.SyntheticEvent<unknown>) => void,
    locales: ILocaleLang[],
    locale: string;
    toggleButtonComponent?: React.FC
    
}
export const LangChooserDropdown = ({ onSelectLang, locales, locale, toggleButtonComponent }: ILangChooserDropdownProps) => (
    <Dropdown align="end" onSelect={onSelectLang}>
        <Dropdown.Toggle as={CustomToggle} toggleButtonComponent={toggleButtonComponent} />
        <Dropdown.Menu>
            {locales.map(({ value, fullName }) => (
                <Dropdown.Item active={value === locale} key={value} eventKey={value}>
                    <LangInfo langName={fullName} />
                </Dropdown.Item>
            ))}
        </Dropdown.Menu>
    </Dropdown>
);
